/* funzioni per cambiare i parametri della pagina valor_inmueble*/

$(document).on("keyup","#affitto-prezzo",function(){
    updateAffittoHref();
    $(this).val(formatNumber($(this).val()));
})
$(document).on("keyup","#affitto-anticipo",function(){
    updateAffittoHref();
    $(this).val(formatNumber($(this).val()));
});


function updateAffittoHref() {
    if ($('input#affitto-prezzo').length) {
        mutuoImmobile = $("#affitto-prezzo").val();
        hrefRichiestaMutuo = $("#richiesta-mutuo").attr("href").split("?")[0];
        $('#richiesta-mutuo').attr("href", hrefRichiestaMutuo +  "?prezzo_affitto="+mutuoImmobile);
    }
}


$( document ).ready(function() {

  $( "#slider-affitto-prezzo" ).slider({
    range: "max",
    min: 1,
    max: 10000,
    value: 1000,
    slide: function( event, ui ) {
      $( "#affitto-prezzo" ).val( formatNumber(ui.value) );
      updateAffittoHref();
    }
  });

//   $( "#slider-affitto-anticipo" ).slider({
//     range: "max",
//     min: 1,
//     max: 200000,
//     value: 20000,
//     slide: function( event, ui ) {
//       $( "#affitto-anticipo" ).val( formatNumber(ui.value) );
//       updateAffittoHref();
//     }
//   });
});